export default {
  en: {
    HEADER_PUBLISHER: 'Publisher',
    HEADER_PINGS: 'Bids',
    HEADER_REJECTED_BIDS: 'Rejected Bids',
    HEADER_WINNING_BIDS: 'Winning Bids',
    HEADER_AVG_BID: 'Avg. Bid',
    HEADER_AVG_WINNING_BID: 'Avg. Winning Bid',
    'HEADER_%_OF_WINNING': 'Win Rate',
    HEADER_RATE_LIMITED: 'Rate Limited',
    HEADER_FINAL_CAPACITY_CHECK: 'Final Capacity Check',
    HEADER_NO_CAPACITY: 'No Capacity',
    HEADER_3RD_PARTY_DATA_ENRICHMENT: '3rd Party Data Enrichment',
    HEADER_CALLER_ID: 'Caller ID',
    HEADER_CALLER_ID_VERIFICATION: 'Caller ID Verification',
    HEADER_DISABLED: 'Disabled',
    HEADER_INITIAL_TAG_FILTER: 'Initial Tag Filter',
    HEADER_FINAL_TAG_FILTER: 'Final Tag Filter',
    RTB_BREAKDOWN_PANE_TITLE: 'RTB Breakdown by Publisher',
    RTB_BREAKDOWN_PANE_EMPTY: 'There are no records for the selected date range.',
    RTB_BREAKDOWN_PANE_TITLE_TT: 'RTB Breakdown by Publisher',
    RTB_REJECTION_BREAKDOWN_PANE_TITLE: 'RTB Rejection Breakdown',
    RTB_REJECTION_BREAKDOWN_PANE_EMPTY: 'There are no records for the selected date range.',
    RTB_REJECTION_BREAKDOWN_PANE_TITLE_TT: 'RTB Rejection Breakdown',

  }
};
